import {
  useGetNominatedPurchasersForOrgQuery,
  useGetStorefrontConfigsQuery,
  useSetStorefrontEnablement,
} from "@fero/hooks";
import { Alert, Typography } from "@mui/material";
import type { OrgSetStorefrontEnablementReq } from "adl-gen/ferovinum/app/api";
import { Loading } from "components/widgets/loader/loader";
import { useCallback } from "react";
import { StorefrontDashboardPageView } from "./storefront-dashboard-page-view";
export const StorefrontDashboardPage = () => {
  const storefrontConfigs = useGetStorefrontConfigsQuery();
  const nominatedPurchasers = useGetNominatedPurchasersForOrgQuery();
  const setStorefrontEnablement = useSetStorefrontEnablement();

  const handleSetStorefrontEnablement = useCallback(
    (configToSet: OrgSetStorefrontEnablementReq) => {
      setStorefrontEnablement.mutate(configToSet);
    },
    [setStorefrontEnablement],
  );

  if (storefrontConfigs.isLoading || nominatedPurchasers.isLoading) {
    return <Loading loading={storefrontConfigs.isLoading} fullScreen={true} />;
  }

  if (
    storefrontConfigs.error ||
    nominatedPurchasers.error ||
    !storefrontConfigs.data
  ) {
    return (
      <Alert severity="error">
        {storefrontConfigs.error && (
          <Typography>
            There was an error loading your Storefront Configurations.
          </Typography>
        )}
        {nominatedPurchasers.error && (
          <Typography>
            There was an error loading your Storefront Purchasers.
          </Typography>
        )}
        {!storefrontConfigs.data && (
          <Typography>Storefront configurations data not found.</Typography>
        )}
      </Alert>
    );
  }
  return (
    <StorefrontDashboardPageView
      storefrontConfigs={storefrontConfigs.data}
      nominatedPurchasersDetailsViews={nominatedPurchasers.data ?? []}
      handleStorefrontEnablement={handleSetStorefrontEnablement}
    />
  );
};
